import { types } from "@proj/static";
import http from "../utils/http";

export const getCountries = async () => {
    let result = await (await http().get(`/country`)).data;
    return result.data;
}